import { Box } from "@itandi/itandi-bb-ui/Box";
import { StatusHandleVendorButtons } from "~/components/common/statuses/StatusHandleVendorButtons";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import { useDeals } from "~/hooks/vendors/useDeals";
import { useSessions } from "~/hooks/vendors/useSessions";
import { ESTIMATION_BY } from "~/models/Deal";
import { isOriginVendor } from "~/models/DealVendorCompany";
import { IN_ESTIMATION, SEND_ESTIMATE } from "~/models/Status";
import Styles from "./statuses.module.scss";

export function SendEstimate() {
	const dealId = useIdQueryHandler();
	const { data: deal } = useDeals().show(dealId);
	const { data: session } = useSessions().index();
	if (deal === null || session === null) return null;

	return (
		<div>
			<h3 className={Styles.Title}>
				{deal.estimationBy === ESTIMATION_BY.COMPANY
					? "見積り確認中です"
					: "見積りを送付しました"}
			</h3>
			<Box marginY={16}>
				<p>施工項目確定をお待ち下さい。</p>
			</Box>
			{isOriginVendor(deal, session.vendorCompany.id) && (
				<StatusHandleVendorButtons
					forwardDisabled
					nextStatusId={SEND_ESTIMATE}
					prevStatusId={
						deal.estimationBy === ESTIMATION_BY.COMPANY ? null : IN_ESTIMATION
					}
				/>
			)}
		</div>
	);
}
